import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-stats-card",
  imports: [CommonModule],
  templateUrl: "./stats-card.component.html",
  styleUrl: "./stats-card.component.scss",
})
export class StatsCardComponent {
  @Input() value: string | number = "";
  @Input() label: string = "";
  @Input() variant: "primary" | "golden" = "primary";
}
